import React, { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive';

function TabStyleButton({buttonPosition,setButtonPosition}) {
    const isMobile = useMediaQuery({ query: "(max-width: 600px)" });
    const [gliderWidth, setGliderWidth] = useState(0);
    useEffect(() => {
        const activeButton = document.querySelector(`.timing_schedule .bold:nth-child(${buttonPosition})`);
        if (activeButton) {
            const buttonWidth = activeButton.offsetWidth;
            setGliderWidth(buttonWidth);
        }
    }, [buttonPosition]);
  return (
    <span className={`timing_schedule flex ${isMobile? 'column textAlign-center':'grey'} mt-1 lighten-4`} style={{width:isMobile?"100%":"560px"}}>
                    <p className={buttonPosition === 1 ? `pointer bold white-text ${isMobile &&'cercle-purple'}` : "pointer"}
                        onClick={() => setButtonPosition(1)}  > All </p>
                    <p className={buttonPosition === 2 ? `pointer bold white-text ${isMobile &&'cercle-purple'}` : "pointer "}
                        onClick={() => setButtonPosition(2)} >Today  </p>
                    <p className={buttonPosition === 3 ? `pointer bold white-text ${isMobile &&'cercle-purple'}` : "pointer "}
                        onClick={() => setButtonPosition(3)} >  Upcoming  </p>
                    <p className={buttonPosition === 4 ? `pointer bold white-text ${isMobile &&'cercle-purple'}` : "pointer "}
                        onClick={() => setButtonPosition(4)} style={{marginRight:"0px"}}>  Paid EMD  </p>
                         <p className={buttonPosition === 5 ? `pointer bold white-text ${isMobile &&'cercle-purple'}` : "pointer "}
                        onClick={() => setButtonPosition(5)} style={{marginRight:"0px"}}>  PCB   </p>
                   {!isMobile && <span className="glider" style={{
                        transform: buttonPosition === 3 ? 'translateX(130%)' :
                            buttonPosition === 4 ? 'translateX(243%)' :
                                buttonPosition === 2 ? 'translateX(77%)' :buttonPosition===5?"translateX(524%)": 'translateX(0%)',
                        width: `${gliderWidth}px`
                    }}></span>}
                </span>
  )
}

export default TabStyleButton
